import React, { useEffect, useState, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import logo from "../../assets/blinkscribelogo.png";
import { useNavigate } from "react-router-dom";
import useModalStore from "zustand/zustandstore";
import api from "api/api";
import dayjs from "dayjs";
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import { clockicon } from "./utils/svg";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTime } from "luxon";

const CareiqSideBar = ({ isSidebarOpen, toggleSidebar }) => {
  const [patients, setPatients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const inputRef = useRef(null);
  const navigate = useNavigate();
const [apipatients,setApiPatients]=useState([])
  const careiqRecord = useModalStore((state) => state.careiqRecord);
  const setModalValue = useModalStore((state) => state.setModalValue);
const [loading,setLoading]=useState(false)
  const jsonFiles = require.context("../jsons", false, /\.json$/);
const [selectedDate, setSelectedDate] = useState(dayjs());
const mydata=useModalStore()
  // Load patient data once
// useEffect(() => {
//   const loadedPatients = jsonFiles.keys().map((key) => {
//     const data = jsonFiles(key);
//     const info = data.patient_info || {};
//     const name = info.name || "Unknown";
//     const demographics = info.demographics || "";
//     const dob = demographics.match(/DOB[:\s]+([\d-]+)/)?.[1] || "N/A";
//     const id = info.id || key.match(/_(\d+)\.json$/)?.[1] || "N/A";

//     return {
//       label: `${name} | DOB: ${dob} | ID: ${id}`,
//       value: key,
//       content: data,
//       id,
//       name,
//       dob,
//     };
//   });

//   // ✅ Deduplicate by `id`
//   const uniquePatients = Array.from(
//     new Map(loadedPatients.map((p) => [p.id, p])).values()
//   );

//   console.log("Unique patients:", uniquePatients.length);

//   setPatients(uniquePatients);
//   setFilteredPatients(uniquePatients);
// }, []);

  // 🔍 Search patients by name or ID
  const handleSearch = (value) => {
    setSearchQuery(value);
    const query = value.trim().toLowerCase();

    if (!query) {
      setFilteredPatients(patients);
      return;
    }

    const matched = patients.filter((p) => {
      const searchString = `${p.name || ""} ${p.id || ""}`.toLowerCase();
      return searchString.includes(query);
    });

    setFilteredPatients(matched);
  };

  // ❌ Clear search when clicking outside the input
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setSearchQuery("");
        setFilteredPatients(patients);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [patients]);

  const handlePatientClick = (patient) => {
    setModalValue({ careiqRecord: patient });
      setModalValue({selectedRecord : patient?.api })    
    toggleSidebar();
  };
const loadAndFilterPatients = async (date) => {
  try {
    // setLoading(true);

    const startDate = dayjs(date).startOf("day").format("YYYY-MM-DD");
    const endDate = dayjs(date).endOf("day").format("YYYY-MM-DD");

    const payload = {
      filter_array: {
        date_filter: {
          start_date: startDate,
          end_date: endDate,
        },
      },
      dash_filter: "ALL",
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      offset: 0,
    };

    const response = await api.post("/v1/appointments/dashboard", payload);
    const apiData = response?.data || [];

    setApiPatients(apiData);

    const apiDataMap = new Map(
      apiData.map((item) => [String(item.patientid), item])
    );

    const loadedPatients = jsonFiles.keys().map((key) => {
      const data = jsonFiles(key);
      const info = data.patient_info || {};
      const name = info.name || "Unknown";
      const demographics = info.demographics || "";
      const dob = demographics.match(/DOB[:\s]+([\d-]+)/)?.[1] || "N/A";
      const id = info.id || key.match(/_(\d+)\.json$/)?.[1] || "N/A";

      const apiObj = apiDataMap.get(String(id));

      return {
        label: `${name} | DOB: ${dob} | ID: ${id}`,
        value: key,
        content: data,
        id,
        name,
        dob,
        ...(apiObj ? { api: apiObj } : {}),
      };
    });

    const uniquePatients = Array.from(
      new Map(loadedPatients.map((p) => [p.id, p])).values()
    );

    const filteredByApi = uniquePatients.filter((p) => p.api);
   


    setPatients(filteredByApi);
    setFilteredPatients(filteredByApi);
  } catch (error) {
    console.error("Error fetching patients:", error);
    setPatients([]);
    setFilteredPatients([]);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  if (!selectedDate) return;

  // Load once immediately
  loadAndFilterPatients(selectedDate);

  // Then set up polling
  const intervalId = setInterval(() => {
    loadAndFilterPatients(selectedDate);
  }, 4000); // every 2 seconds

  // Cleanup interval on unmount or when date changes
  return () => clearInterval(intervalId);
}, [selectedDate]);

useState(()=>{
  if (
  patients.length > 0 &&
  (
    !mydata.selectedRecord ||
    Object.keys(mydata.selectedRecord).length === 0 ||
    mydata.selectedRecord.id !== patients.id
  )
) {
  setModalValue({ careiqRecord: patients[0] });
  setModalValue({ selectedRecord: patients[0]?.api });
}
},[patients])
  const renderStatus = (item) => {
      // const isSelected =  selectedRecord?.patientid === item.patientid;

      const isSelected = mydata.usertype === 'BUSINESS' 
      ?  careiqRecord?.id === item.id 
      :  careiqRecord?.patientid === item.patientid;
   
     if (item.transcriptionstatus === null || item.transcriptionstatus === "") {
       return <div className={`rounded-full px-2 py-1 text-xs font-medium ${isSelected?" bg-[#DBEAFE] text-[#166534]":"text-[#166534] border shadow-[0px_0px_1px_0px_rgba(0,0,0,0.25)] bg-[#F7F7F7] "}`}>Ready</div>;
     } else if (item.transcriptionstatus === "Submitted") {
       return <div className='rounded-full px-2 py-1 text-sm font-medium bg-[#FEF9C3] text-[#854D0E] '>{"20%"}</div>
   
     } else if (item.transcriptionstatus === "Processing") {
       const recording_duration = item?.recording_duration || 200; // Fallback to a default value
       const totalProcessingTime = Math.max((420 / 1287) * recording_duration, 60);
     let ts="2025-05-12T18:43:34" //8:38 pro
     let ts1='2025-05-12T20:42:10' //8:42  plus
     const recordingStartTime = DateTime.fromISO(item?.ts).toSeconds();
 
   
   // Current time in UTC, rounded to whole seconds
   const currentTime = Math.floor(DateTime.now().toSeconds()); // or you can use Math.round() if you prefer rounding
 
      
       const elapsedSinceStart = Math.max(currentTime - recordingStartTime, 0);
 
       // Calculate the initial percentage based on the elapsed time
       const completionPercentage = Math.min(
         Math.round(20 + (70 * elapsedSinceStart) / totalProcessingTime),
         90
       );
 
   
   
   
   
   
   return <div className='rounded-full px-2 py-1 text-sm font-medium bg-[#FEF9C3] text-[#854D0E]'>{completionPercentage+"%"}</div>
   
     } else if (item.transcriptionstatus === "Summarized") {
     
       return (
         <div className="ml-2" >
           <Tooltip title="Pending Review">
             {/* <img src={summarizedpng} alt="pending review" className="w-6 h-6" /> */}
             <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 25 31" fill="none">
  <path d="M7.87484 17.0423C7.87484 18.2689 8.36211 19.4453 9.22947 20.3127C10.0968 21.18 11.2732 21.6673 12.4998 21.6673C13.7265 21.6673 14.9029 21.18 15.7702 20.3127C16.6376 19.4453 17.1248 18.2689 17.1248 17.0423C17.1248 15.8157 16.6376 14.6393 15.7702 13.7719C14.9029 12.9046 13.7265 12.4173 12.4998 12.4173C11.2732 12.4173 10.0968 12.9046 9.22947 13.7719C8.36211 14.6393 7.87484 15.8157 7.87484 17.0423ZM24.8332 27.2019V9.33398L15.5832 0.0839844H3.24984C2.43209 0.0839844 1.64783 0.408835 1.06959 0.987072C0.491354 1.56531 0.166504 2.34957 0.166504 3.16732V27.834C0.166504 28.6517 0.491354 29.436 1.06959 30.0142C1.64783 30.5925 2.43209 30.9173 3.24984 30.9173H21.7498C22.4436 30.9173 23.0603 30.6861 23.5844 30.3007L16.7548 23.4711C15.5215 24.2727 14.0415 24.7507 12.4998 24.7507C10.4555 24.7507 8.49481 23.9385 7.04922 22.4929C5.60363 21.0473 4.7915 19.0867 4.7915 17.0423C4.7915 14.9979 5.60363 13.0373 7.04922 11.5917C8.49481 10.1461 10.4555 9.33398 12.4998 9.33398C14.5442 9.33399 16.5049 10.1461 17.9505 11.5917C19.396 13.0373 20.2082 14.9979 20.2082 17.0423C20.2082 18.584 19.7303 20.064 18.9286 21.2819L24.8332 27.2019Z" fill="#DE8276"/>
</svg>
           </Tooltip>
         </div>
       );
     } else if (item.transcriptionstatus === "APPROVED") {
       return (
         <div className="ml-2">
           <Tooltip title="Completed">
             {/* <img src={checkmark} alt="Completed" className="w-6 h-6" /> */}
             <div 
            
             className={`rounded-full px-2 py-1 text-xs font-medium bg-[#DBEAFE] text-[#1E40AF]`}>Signed Off</div>
           </Tooltip>
         </div>
       );
     } else {
       return null;
     }
   }


  return (
 <div
  className={`
    h-screen w-72 bg-white shadow-md
    flex flex-col items-center justify-start gap-4
    rounded-tr-md
    ${isSidebarOpen ? "block" : "hidden"}
  `}
>
      {/* Close Button */}
<div className="w-full flex justify-end mb-2 border-b     rounded-tr-md min-h-[60px] border-b-[#E5E7EB] bg-[#A2C6FD]">
  <button onClick={toggleSidebar} className="text-xl text-white font-bold px-3 py-1">
    ✕
  </button>
</div>
{/* Date Picker */}
<div className="w-full px-3 mt-2">
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      value={selectedDate}
      onChange={(newValue) => setSelectedDate(newValue)}
      format="MM/DD/YYYY"
      slotProps={{
        textField: {
          fullWidth: true,
          size: "small",
          sx: { backgroundColor: "white" },
        },
      }}
    />
  </LocalizationProvider>
</div>


{/*      
      <div className="w-full flex flex-col justify-center items-center">
        <img
          onClick={() => {
            navigate("/v2");
            toggleSidebar();
          }}
          src={logo}
          alt="CareIQ Logo"
          className="w-36 mx-auto cursor-pointer"
        />
      </div> */}

      {/* Search Box */}
      <div className="w-full px-3">
        <div className="relative w-full" ref={inputRef}>
        <div className="flex items-center w-full px-3  py-2 rounded-md border  border-[#E5E7EB] bg-white rounded-md">
          <FaSearch className="text-gray-500" />
          <input
            placeholder="Search Patient by Name or ID"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            type="text"
            className="w-full bg-transparent outline-none pl-2 text-gray-700"
          />
          {searchQuery && (
            <button
              className="ml-2 text-gray-500 hover:text-black"
              onClick={() => {
                handleSearch(""); // ✅ Clears search and shows all patients
              }}
            >
              ✕
            </button>
          )}
        </div>
      </div>
      </div>
      

      {/* Patient List */}
      <div className="w-full overflow-auto max-h-96 mt-2">
        {filteredPatients.length > 0 ? (
          filteredPatients.map((patient,index) => (
 <div
  key={index}
  className={`p-3 mb-2 text-start border cursor-pointer transition-all ${
    careiqRecord?.id === patient.id
      ? "bg-[#EFF6FF] border-l-[6px] border-l-[#2B7FFF]"
      : "hover:bg-gray-100"
  }`}
  onClick={() => handlePatientClick(patient)}
>
  <div className="flex gap-2 items-center">
<div
  className="text-xs font-medium text-white rounded-full w-10 h-10 flex items-center justify-center"
  style={{
    background: "#607ca4",
  }}
>
  {patient.name
    ?.split(" ")
    .map(word => word.charAt(0).toUpperCase())
    .join("")}
</div>

<div>
 <div className="text-sm font-medium flex items-center gap-2">
    {patient.name}
    <span className="text-xs text-[#6A7282]">({patient.id})</span>
  </div>
<div className="flex justify-between">
   {patient?.api?.startdate && (
    <div className="text-xs flex gap-1 items-center text-[#6A7282] mt-1">
     {clockicon} {dayjs(patient.api.startdate).format("h:mm A")}
    </div>
  )}
{renderStatus(patient?.api)}

</div>

</div>
  </div>

 
</div>


          ))
        ) : (
          <div className="text-sm text-gray-500 text-center">No patients found</div>
        )}
      </div>
       <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress color="inherit" size={40} />
            </Backdrop>
    </div>
  );
};

export default CareiqSideBar;
